import { requestMembership, useAccountSession, type MemberInfo } from '@/deployment/accountSession';

export type IMemberInfo = MemberInfo;
const free: IMemberInfo = { isMember: false, planType: 'none' };

export function useMemberStatus() {
  const { user } = useAccountSession();
  return { member: user?.member || free, activateMembership: requestMembership };
}
